<template>
  <header class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container">
      <router-link to="/" class="navbar-brand"
        ><img width="200" alt="Logo" src="@/assets/logo.png"
      /></router-link>
      <div>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="isloggedIn">
            <router-link to="/cart"
              >Cart ({{ $store.getters.cartLength }})</router-link
            >
            |
            <button @click="signOut">Sign out</button>
          </li>
          <li v-else>
            <router-link to="/login">Login</router-link>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import firebase from "firebase";
export default {
  name: "Header",
  data() {
    return {
      isloggedIn: false,
      currentUser: false
    };
  },
  mounted() {
    this.setupFirebase();
  },
  methods: {
    setupFirebase() {
      firebase.auth().onAuthStateChanged(user => {
        if (user) {
          // User is signed in.
          console.log("signed in");
          this.isloggedIn = true;
        } else {
          // No user is signed in.
          this.isloggedIn = false;
          console.log("signed out");
        }
      });
    },
    signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({ name: "login" });
        });
    }
  }
};
</script>

<style></style>
